function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1904(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.27,
    height: 5.27,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.8783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 2.635
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.27,
    width: 23.27,
    height: 24.07,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 17.305
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29.35,
    width: 23.27,
    height: 45.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5855555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 51.995000000000005
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 74.64,
    width: 23.27,
    height: 51.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 100.4
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 126.15,
    width: 23.27,
    height: 54.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3242857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 153.56
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180.97,
    width: 23.27,
    height: 58.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8783333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 210
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 239.03,
    width: 23.27,
    height: 65.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.654
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 271.96500000000003
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 304.9,
    width: 23.27,
    height: 68.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.90875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 339.03999999999996
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 373.19,
    width: 23.27,
    height: 68.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8783333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 407.585
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 441.98,
    width: 23.27,
    height: 77.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8783333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 480.6
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 519.22,
    width: 23.27,
    height: 89.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 564.065
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 608.91,
    width: 23.27,
    height: 91.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8783333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.635,
    y: 654.4549999999999
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 0,
    width: 41.71,
    height: 53.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.951666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.125,
    y: 26.785
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.98,
    y: 0,
    width: 42.18,
    height: 53.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.436
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.07000000000001,
    y: 26.785
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.16,
    y: 0,
    width: 44.94,
    height: 53.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.494
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.63,
    y: 26.785
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.1,
    y: 0,
    width: 52.2,
    height: 53.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.440000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.2,
    y: 26.785
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.3,
    y: 0,
    width: 52.2,
    height: 53.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.700000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.4,
    y: 26.785
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 0,
    width: 53.77,
    height: 53.57,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.3925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.385,
    y: 26.785
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.26,
    y: 0,
    width: 54.65,
    height: 53.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.928333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.585,
    y: 26.785
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.92,
    y: 0,
    width: 60.45,
    height: 53.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.928333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.14500000000004,
    y: 26.785
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.36,
    y: 0,
    width: 63.65,
    height: 53.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.952222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.185,
    y: 26.785
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.01,
    y: 0,
    width: 64.8,
    height: 53.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.928333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.41,
    y: 26.785
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.81,
    y: 0,
    width: 72.42,
    height: 53.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.69625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 590.02,
    y: 26.785
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 626.23,
    y: 0,
    width: 73.77,
    height: 53.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.952222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.115,
    y: 26.785
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 53.57,
    width: 66.97,
    height: 60.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.053
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 83.83500000000001
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 114.11,
    width: 66.97,
    height: 68.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.394
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 148.425
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 182.74,
    width: 66.97,
    height: 68.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.567142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 217.21
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 251.68,
    width: 66.97,
    height: 69.18,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.441111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 286.27
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 320.86,
    width: 66.97,
    height: 72.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.161666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 356.985
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 393.12,
    width: 66.97,
    height: 72.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 429.325
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 465.52,
    width: 66.97,
    height: 75.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.161666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 503.39
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 541.26,
    width: 66.97,
    height: 77.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.37125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 580.165
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 619.08,
    width: 66.97,
    height: 80.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.185625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.754999999999995,
    y: 659.5400000000001
  }, "\n        San_Luis__Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 53.57,
    width: 69.83,
    height: 81.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.638333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 94.1
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.07,
    y: 53.57,
    width: 69.85,
    height: 81.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.995,
    y: 94.1
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.92,
    y: 53.57,
    width: 73.73,
    height: 81.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.192222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.78499999999997,
    y: 94.1
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.65,
    y: 53.57,
    width: 75.59,
    height: 81.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.44875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.445,
    y: 94.1
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.25,
    y: 53.57,
    width: 77.64,
    height: 81.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.972307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.07,
    y: 94.1
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.88,
    y: 53.57,
    width: 78.93,
    height: 81.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.893000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.345,
    y: 94.1
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.81,
    y: 53.57,
    width: 81.61,
    height: 81.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.6149999999999,
    y: 94.1
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.42,
    y: 53.57,
    width: 82.58,
    height: 81.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.7099999999999,
    y: 94.1
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 134.63,
    width: 97.23,
    height: 69.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.575000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.855,
    y: 169.355
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 204.08,
    width: 97.23,
    height: 69.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.855,
    y: 238.82000000000002
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 273.57,
    width: 97.23,
    height: 71.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9688888888888885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.855,
    y: 309.43
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 345.29,
    width: 97.23,
    height: 72.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.855,
    y: 381.44500000000005
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 417.6,
    width: 97.23,
    height: 78.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.111666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.855,
    y: 456.935
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 496.26,
    width: 97.23,
    height: 101.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.855,
    y: 546.955
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.24,
    y: 597.65,
    width: 97.23,
    height: 102.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.15375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.855,
    y: 648.8249999999999
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.46,
    y: 134.63,
    width: 87.96,
    height: 121.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.773333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.44,
    y: 195.37
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.42,
    y: 134.63,
    width: 88.76,
    height: 121.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.06909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.8,
    y: 195.37
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.18,
    y: 134.63,
    width: 103.99,
    height: 121.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.331666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.175,
    y: 195.37
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.17,
    y: 134.63,
    width: 107.5,
    height: 121.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.916666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.9200000000001,
    y: 195.37
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.67,
    y: 134.63,
    width: 124.33,
    height: 121.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.148
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.8349999999999,
    y: 195.37
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.46,
    y: 256.11,
    width: 131.94,
    height: 140.21,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.994545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.43,
    y: 326.21500000000003
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.46,
    y: 396.32,
    width: 131.94,
    height: 303.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.84857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.43,
    y: 548.16
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 256.11,
    width: 380.6,
    height: 189.82,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.256363636363634
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.7,
    y: 351.02
  }, "\n        Los_Angeles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 445.94,
    width: 380.6,
    height: 254.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.543076923076924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.7,
    y: 572.97
  }, "\n        San_Francisco\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1904);
export default __webpack_public_path__ + "static/media/1904.c390cbaa9e29d7c97209a8e5430837c2.svg";
export { ForwardRef as ReactComponent };